// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgLevelHigh = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <rect
      width={5}
      height={6.667}
      x={1.667}
      y={11.668}
      fill="currentColor"
      rx={1}
    />
    <rect
      width={5}
      height={11.667}
      x={7.5}
      y={6.668}
      fill="currentColor"
      rx={1}
    />
    <rect
      width={5}
      height={16.667}
      x={13.333}
      y={1.668}
      fill="currentColor"
      rx={1}
    />
  </svg>
);
export const LevelHighIcon = forwardRef(SvgLevelHigh);
